import * as React from "react"

const PortalContainerContext = React.createContext<HTMLElement | undefined>(undefined)

/** Renders overlays (sheets, dialogs, popovers, menus, tooltips, toasts) inside `container` instead of `document.body`. */
function PortalContainerProvider({
  container,
  children,
}: {
  /** The element the overlays below are rendered in. `null`, for an element that is not mounted yet, uses `document.body`. */
  container: HTMLElement | null
  children?: React.ReactNode
}) {
  return <PortalContainerContext.Provider value={container ?? undefined}>{children}</PortalContainerContext.Provider>
}

/** The element overlays should portal into, or `undefined` for the default (`document.body`). */
function usePortalContainer(): HTMLElement | undefined {
  return React.useContext(PortalContainerContext)
}

export { PortalContainerProvider, usePortalContainer }
